<template>
  <div id="root" class="toggle-menu">
    <menu-component whiteFont="true"></menu-component>
    <b-row class="full-height bg-img">
      <b-container class="alinov-header center-text">
        <b-row>
          <b-col>
            <h1>Kolectiva</h1>
            <br/><br/>
            <a class="link-to-section" href="#kolectiva">
              <i class="fas fa-chevron-circle-down"></i>
            </a>
          </b-col>
        </b-row>
      </b-container>
      <div id="kolectiva" class="alinov-info-container">
        <b-container class="info">
					<b-row class="title">
            <b-col>
              <h4>
                Nuestra Filosofia <br> <br>
              </h4>
              <p>
             "El pez más grande se come al chico” y en consecuencia siempre habrá una desventaja comercial. 
              Tenemos como objetivo principal ser una herramienta de toma de decisiones inteligentes para 
              que pequeños compradores tengan acceso a mejores condiciones de compra mientras forman parte 
              de una comunidad en crecimiento de compradores empoderados. 
              </p>
              <p>
              Cuando las personas se organizan y logran comunicarse de manera efectiva y eficiente, 
              grandes cosas pueden suceder. En Kolectiva, buscamos que más personas se unan para ser
              parte de una comunidad exclusiva de compradores con el poder de la información a su favor.  
              </p>
	   </b-col>
          </b-row>
	  <h3>HACIENDO PRESENCIA EN LA REGIÓN VALLES</h3>
		<img src="../assets/images/maps.jpg" align="center" width="300" height="333">
		<img src="../assets/images/kolectiva.jpg" align="right" width="300" height="333">
		
		<b-row class="title">
                <h2> Envíanos un mensaje
              </h2>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                <b-form-group
                  id="email_address_gr"
                  label="Correo Electrónico:"
                  label-for="email_address_input"
                >
                  <b-form-input
                    id="email_address_input"
                    type="email"
                    v-model="form.email"
                    required
                    placeholder="Escribe tu correo electrónico"
                  />
                </b-form-group>

                <b-form-group id="name_gr" label="Nombre:" label-for="name_input">
                  <b-form-input
                    id="name_input"
                    type="text"
                    v-model="form.name"
                    required
                    placeholder="Escribe tu nombre"
                  />
                </b-form-group>

								<b-form-group id="subject_gr" label="Asunto:" label-for="subject_input">
                  <b-form-input
                    id="subject_input"
                    type="text"
                    v-model="form.subject"
                    required
                    placeholder="Escribe un asunto"
                  />
                </b-form-group>

								<b-form-group label="Mensaje:" label-for="message_ts">
									<b-form-textarea
										id="message_ts"
										v-model="form.message"
										placeholder="Agrega un mensaje"
										required
										rows="3"
										max-rows="6"
									/>
								</b-form-group>

                <b-button class="alinov" type="submit" variant="success">Enviar</b-button>
              </b-form>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-row>
    <footer-component></footer-component>
  </div>
</template>

<script>
import Menu from "../shared/Menu.vue";
import Footer from "../shared/Footer.vue";
import $ from 'jquery'

export default {
  name: "Kolectiva",
  components: {
    "menu-component": Menu,
    "footer-component": Footer
  },
  beforeMount() {
    $(function() {
      $('a.link-to-section').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top-80}, 500, 'linear');
      });
    });
    
    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      var headerHeight = 500;
      
      if (scroll >= headerHeight) {
        $(".toggle-menu .alinov-navbar:not(#nav-mobile)").addClass("white-bg");
        $(".toggle-menu .alinov-navbar:not(#nav-mobile)").removeClass("white-font");
      } else {
        $(".toggle-menu .alinov-navbar:not(#nav-mobile)").removeClass("white-bg");
        $(".toggle-menu .alinov-navbar:not(#nav-mobile)").addClass("white-font");
      }
    });
  },
	data() {
      return {
        userId: process.env.VUE_APP_EMAIL_USER_ID,
        form: {
          email: '',
					name: '',
					message: '',
					subject: ''
        },
        show: true
      }
    },
    methods: {
      onSubmit(evt) {
        evt.preventDefault()
        
        var data = {
            service_id: 'gmail',
            template_id: 'template_9F9SQSC9',
            user_id: this.userId,
            template_params: {
                'from_email': this.form.email,
                'reply_to': this.form.email,
                'from_name': this.form.name,
                'message': this.form.message,
                'subject': this.form.subject
            }
        };
        
        $.ajax('https://api.emailjs.com/api/v1.0/email/send', {
            type: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json'
        }).done(function() {
            alert('¡Tu correo ha sido enviado!');
        }).fail(function() {
            alert('Ocurrió un error. Vuelte a intentarlo más tarde.');
        });
      },
      onReset(evt) {
        evt.preventDefault()
        this.form.email = ''
				this.form.name = ''
				this.form.message = ''
				this.form.subject = ''
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
			}
		}
};
</script>

<style lang="scss" scoped>
.full-height {
	background-image:linear-gradient( 
    rgba(0, 0, 0, 0.5), 
    rgba(0, 0, 0, 0.5) ), 
		url("../assets/images/LogoKolectiva.png");
		background-position-y: 20%;
}
.alinov-info-container .info.container .row {
	h2 {
		font-size: 40px;
	}
}
.alinov-info-container .info.container .row.title {
	padding-top: 1rem;
}
.w-border {
	border-bottom: 1px solid rgba(0,0,0,0.1);
} 
.img-col .img-fluid {
	width: 80%;
}
</style>
